import axiosInstance from "../../../services/axiosInstance";


export const getProducts = async (params = {}) => {
    const response = await axiosInstance.get('products/products',  {params} );
    return response.data;
};
export const getDiscountedProducts = async (params = {}) => {
    const response = await axiosInstance.get('products/discounts',  {params} );
    return response.data;
};

export const getProductGroup = async (id ) => {
    const response = await axiosInstance.get(`products/groups/${id}` );
    return response.data;
};
export const getProduct = async (id , params ) => {
    const response = await axiosInstance.get(`products/products/${id}` ,  {params});
    return response.data;
};


export const getBrands = async (params = {}) => {
    const response = await axiosInstance.get('products/brands',  {params} );
    return response.data;
};
export const makeFavorite = async (id ,params = {}) => {
    const response = await axiosInstance.get(`products/favorite/${id}`,  {params} );
    return response.data;
};
export const getFavorites = async (params = {}) => {
    const response = await axiosInstance.get(`products/favorite-list`,  {params} );
    return response.data;
};